var map = {
	"./Red0.png": "54e3",
	"./Red1.png": "5d45",
	"./Red10.png": "2c3f",
	"./Red11.png": "d4ed",
	"./Red12.png": "11a2",
	"./Red13.png": "43af",
	"./Red16.png": "dcd2",
	"./Red17.png": "5c7f",
	"./Red19.png": "c834",
	"./Red2.png": "73a5",
	"./Red21.png": "16ec",
	"./Red23.png": "362a",
	"./Red25.png": "5c34",
	"./Red29.png": "0001",
	"./Red3.png": "74ee",
	"./Red31.png": "6fe5",
	"./Red33.png": "d666",
	"./Red35.png": "22e4",
	"./Red37.png": "62c4",
	"./Red39.png": "01a0",
	"./Red47.png": "a22e",
	"./Red6.png": "7afc",
	"./Red7.png": "2384",
	"./Red8.png": "ed84",
	"./Red9.png": "ffba",
	"./RedOther.png": "92ac",
	"./Yellow0.png": "fb67",
	"./Yellow1.png": "8324",
	"./Yellow10.png": "46b9",
	"./Yellow11.png": "1619",
	"./Yellow12.png": "d216",
	"./Yellow13.png": "b16b",
	"./Yellow16.png": "91b4",
	"./Yellow17.png": "1f6f",
	"./Yellow19.png": "01fc",
	"./Yellow2.png": "c7bd",
	"./Yellow21.png": "2522",
	"./Yellow23.png": "a4c6",
	"./Yellow25.png": "797f",
	"./Yellow29.png": "4c12",
	"./Yellow3.png": "3544",
	"./Yellow31.png": "d956",
	"./Yellow33.png": "4556",
	"./Yellow35.png": "b4af",
	"./Yellow37.png": "c812",
	"./Yellow39.png": "b494",
	"./Yellow41.png": "66ae",
	"./Yellow47.png": "4799",
	"./Yellow6.png": "48ac",
	"./Yellow7.png": "ee70",
	"./Yellow8.png": "46ee",
	"./Yellow9.png": "ede5",
	"./YellowOther.png": "7cc2",
	"./on0.png": "446f",
	"./on1.png": "c8c2",
	"./on10.png": "b10f",
	"./on11.png": "053c",
	"./on12.png": "db83",
	"./on13.png": "ba91",
	"./on16.png": "5fbc",
	"./on17.png": "8995",
	"./on19.png": "cabf",
	"./on2.png": "9280",
	"./on21.png": "8aca",
	"./on23.png": "918f",
	"./on25.png": "3bb6",
	"./on29.png": "35eb",
	"./on3.png": "fc6b",
	"./on31.png": "d84c",
	"./on33.png": "92bf",
	"./on35.png": "6d48",
	"./on37.png": "0065",
	"./on39.png": "0b73",
	"./on41.png": "0bd4",
	"./on47.png": "94e7",
	"./on6.png": "217a",
	"./on7.png": "4643",
	"./on8.png": "10a7",
	"./on9.png": "2369",
	"./onOther.png": "6440",
	"./out0.png": "f6d5",
	"./out1.png": "c8a5",
	"./out10.png": "99e2",
	"./out11.png": "1afe",
	"./out12.png": "1982",
	"./out13.png": "ac96",
	"./out16.png": "5cb0",
	"./out17.png": "c156",
	"./out19.png": "ab2a",
	"./out2.png": "2e42",
	"./out21.png": "b24c",
	"./out23.png": "ec17",
	"./out25.png": "ccd6",
	"./out29.png": "eb62",
	"./out3.png": "29db",
	"./out31.png": "a362",
	"./out33.png": "6a85",
	"./out35.png": "99be",
	"./out37.png": "fb3c",
	"./out39.png": "6871",
	"./out41.png": "aac5",
	"./out47.png": "3e2f",
	"./out6.png": "df02",
	"./out7.png": "5754",
	"./out8.png": "01b9",
	"./out9.png": "5fa8",
	"./outOther.png": "f23b",
	"./星图-设备类型.png": "c8b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4613";